import { Fragment, useEffect, useState } from "react";
import HeaderOne from "../component/layout/header";
import { getAnyUser, getUser } from "../scripts/auth/user_data";
import { useParams } from 'react-router';
import '../assets/css/extra/profile_template/demo.css';
import '../assets/css/extra/profile_template/style.css';
import { calcCrow } from "../scripts/utils/utils";
import { calculateDistance, getMatchId } from "../scripts/home/hometwo";

const Profile = () => {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [matchId, setMatchId] = useState(null)

    const loadUserData = async (idVal) => {
        const currentUserData = await getUser(localStorage.getItem("user-id"));
        setCurrentUser(currentUserData);
        if (currentUserData?.profilePicture && document.getElementById("content_avatar")) {
            document.getElementById("content_avatar").style.background = currentUserData.profilePicture;
        }
        const userData = await getAnyUser(idVal);
        setUser(userData);
        const matchIdData = await getMatchId(localStorage.getItem("user-id"), idVal)
        setMatchId(matchIdData)
    };

    useEffect(() => {
        loadUserData(id)
    }, [id]);

    const handleActionClick = (platform) => {
        if (!currentUser) return window.location.href = "../../login";
        if ((currentUser.gender === "male" || currentUser.gender === "erkek") && !currentUser.purchaseStatus) {
            return window.location.href = "../../premium";
        }
    };

    const getUserLocation = (location) => {
        if (!currentUser) return null;
        return calculateDistance(currentUser.userAccountSettingsModel.location.latitude, currentUser.userAccountSettingsModel.location.longitude, location.latitude, location.longitude).toFixed().toString() + " km uzaklıkta"
    }

    return (
        <Fragment>
            <HeaderOne assetPrefix="../" />
            {user ? (
                <main className="profile_thingy cd__main">
                    <div className="profile-page">
                        <div className="content">
                            <div className="content__cover">
                                <img id="content_avatar" className="content__avatar" src={user.profilePicture || "https://www.pngrepo.com/png/384674/180/account-avatar-profile-user-11.png"} />
                            </div>
                            <div className="content__actions">
                                <a href="#"></a>
                                <a href={`../../chats/${user.userId}/${(matchId) ? matchId : currentUser ? (currentUser.userId + user.userId) : ""}`}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                    <path
                                        fill="currentColor"
                                        d="M208 352c-41 0-79.1-9.3-111.3-25-21.8 12.7-52.1 25-88.7 25a7.83 7.83 0 0 1-7.3-4.8 8 8 0 0 1 1.5-8.7c.3-.3 22.4-24.3 35.8-54.5-23.9-26.1-38-57.7-38-92C0 103.6 93.1 32 208 32s208 71.6 208 160-93.1 160-208 160z"
                                    />
                                    <path
                                        fill="currentColor"
                                        d="M576 320c0 34.3-14.1 66-38 92 13.4 30.3 35.5 54.2 35.8 54.5a8 8 0 0 1 1.5 8.7 7.88 7.88 0 0 1-7.3 4.8c-36.6 0-66.9-12.3-88.7-25-32.2 15.8-70.3 25-111.3 25-86.2 0-160.2-40.4-191.7-97.9A299.82 299.82 0 0 0 208 384c132.3 0 240-86.1 240-192a148.61 148.61 0 0 0-1.3-20.1C522.5 195.8 576 253.1 576 320z"
                                    />
                                </svg><span>Mesaj At</span></a>
                            </div>
                            <div className="content__title">
                                <h1>{user.fullName}</h1>
                                <i style={{ paddingRight: 6 }} className={`fa fa-location-dot`}></i>{user.userAccountSettingsModel && <span>{getUserLocation(user.userAccountSettingsModel.location)}</span>}
                            </div>
                            {user.about && <div className="content__description"><p>{user.about}</p></div>}
                            {user.gender && (
                                <div className="content__description gender-layout">
                                    <div className="gender-lay2">
                                        <i className={`male-female fa-solid ${user.gender === "male" || user.gender === "erkek" ? "fa-mars" : "fa-venus"}`}></i>
                                        <p>{user.gender === "male" || user.gender === "erkek" ? "Erkek" : "Kadın"}</p>
                                    </div>
                                </div>
                            )}
                            <div className="info-lay">
                                {["instagram", "whatsapp", "phone"].map((platform, i) => (
                                    <div key={i} onClick={() => handleActionClick(platform)} className={`social-lay ${!currentUser || currentUser.gender === "male" && !currentUser.purchaseStatus ? "animate" : ""} ${platform === 'instagram' ? 'pink' : platform === 'whatsapp' ? 'green' : 'blue'}`}>
                                        <span className="social-lay-span">
                                            <i style={{ paddingRight: 6 }} className={`fa fa-${platform}`}></i>
                                            <p>{!currentUser ? `${i === 0 ? "Instagramı" : i === 1 ? "Whatsappı" : "Telefonu"} gör` : (currentUser.gender === "male" && !currentUser.purchaseStatus ? `${i === 0 ? "Instagramı" : i === 1 ? "Whatsappı" : "Telefonu"} gör` : user[platform] || `${i === 0 ? "Instagram" : i === 1 ? "Whatsapp" : "Telefon"} yok`)}</p>
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </main>
            ) : (
                <div id="loading" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 600 }}>
                    <span className="loader" style={{ width: 48, height: 48 }}></span>
                </div>
            )}
        </Fragment>
    );
};

export default Profile;
